import { Button, Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import QuickForm from "../../Components/Forms/QuickForm/QuickForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers"
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook"
import { useGetPropertyAmenitiesQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"
import { PropertyAmenityType } from "../../Types/propertyAmenityTypes"
import PropertyAmenityEntry from "../../Components/PropertyAmenity/PropertyAmenityEntry/PropertyAmenityEntry"
import useMyProperties from "../../Hooks/UseMyProperties/UseMyPropertiesHook"
import useMyPropertiesSelectValues from "../../Hooks/UseMyProperties/UseMyPropertySelectValuesHook"
import useAmenitySelectValues from "../../Hooks/UseAmenities/useAmenitySelectValuesHook"

export default function PropertyAmenitiesPage() {

    const dispatch = useAppDispatch()

    const { myProperties } = useMyProperties()
    const propertyOptions = useMyPropertiesSelectValues(myProperties)
    const amenityOptions = useAmenitySelectValues()

    const { activeQuery } = useActiveQueryHook({
        query: {},
        limit: 10,
    })

    const {
        data,
        error,
        isLoading,
    } = useGetPropertyAmenitiesQuery({
        propertyAmenitiesQuery: activeQuery.query,
        pagination: {
            page: activeQuery.page,
            limit: activeQuery.limit,
        }
    })
    const propertyAmenitiesList = data?.docs || []

    const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
        const destination = `/property-amenities?${convertActiveQueryToUrl(pageParams)}`
        dispatch(navigateTo(destination))
    }

    return (
        <Container>
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>Property Amenities</h1>
                        <Button
                            variant="primary"
                            onClick={() => dispatch(navigateTo('/add-property-amenity'))}
                        >
                            Add Property Amenity
                        </Button>
                    </div>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <QuickForm
                        layout={{ xs: 2 }}
                        initialData={{
                            propertyId: activeQuery.query.propertyId,
                            amenityId: activeQuery.query.amenityId,
                        }}
                        fields={[
                            {
                                fieldName: 'propertyId',
                                fieldLabel: 'Property',
                                fieldType: 'select',
                                placeholder: '- All Properties -',
                                options: propertyOptions,
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                            {
                                fieldName: 'amenityId',
                                fieldLabel: 'Amenity',
                                fieldType: 'select',
                                placeholder: '- All Amenities -',
                                options: amenityOptions,
                                layout: {
                                    xs: 12,
                                    md: 6,
                                }
                            },
                        ]}
                        disabled={isLoading}
                        onSubmit={(values: any) => {
                            const query: any = { ...values }
                            loadPage({
                                query,
                                page: 1,
                                limit: activeQuery.limit
                            })
                        }}
                    />

                    <div className="property-amenities-list-container">
                        {propertyAmenitiesList && propertyAmenitiesList.length > 0 ? (
                            <div>
                                {propertyAmenitiesList.map((propertyAmenity: PropertyAmenityType, idx: number) => {
                                    return (
                                        <PropertyAmenityEntry
                                            key={`${propertyAmenity._id}-${idx}`}
                                            propertyAmenityData={propertyAmenity}
                                        />
                                    )
                                })}
                            </div>
                        ) : (
                            <div className="text-center p-4">
                                <h5>No property amenities found</h5>
                                <p>Try adjusting your search filters or add a new property amenity.</p>
                            </div>
                        )}
                    </div>

                    <MongoPagination
                        data={data}
                        loadPage={(pageLoadInfo: { page: number, limit?: number }) => {
                            loadPage({
                                query: activeQuery.query,
                                limit: activeQuery.limit,
                                ...pageLoadInfo
                            })
                        }}
                    />
                </Col>
            </Row>
        </Container>
    )
}
